import { localStoragePrefix } from '@/config';
import { TOKEN } from '../constants';

export default {
  authStatus: '',
  token: localStorage.getItem(localStoragePrefix + TOKEN) || null,
  user: {},
  isAuthenticated: localStorage[localStoragePrefix + 'TOKEN'] ? true : false,
};
